import { Link } from "react-router-dom";
import { ArrowLeft } from "../components/common/Icons";

const RulingsPage = () => {
  return (
    <div className="min-h-screen bg-black pt-20 flex items-center justify-center" data-testid="rulings-page">
      <div className="container mx-auto px-4">
        <div className="max-w-lg mx-auto text-center">
          {/* Coming Soon Animation */}
          <div className="relative mb-8">
            <div className="w-32 h-32 mx-auto bg-gradient-to-br from-purple-600 via-pink-500 to-red-500 rounded-full flex items-center justify-center shadow-2xl shadow-purple-500/30 animate-pulse">
              <span className="text-6xl">📜</span>
            </div>
            <div className="absolute inset-0 w-32 h-32 mx-auto border-4 border-dashed border-yellow-400/30 rounded-full animate-spin" style={{ animationDuration: '10s' }}></div>
          </div>

          {/* Title */}
          <h1 className="text-3xl md:text-4xl font-black mb-4">
            <span className="bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-500 bg-clip-text text-transparent">
              Rulings
            </span>
          </h1>

          {/* Coming Soon Badge */}
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-900/50 to-pink-900/50 border border-purple-500/50 rounded-full mb-6">
            <span className="w-3 h-3 bg-yellow-400 rounded-full animate-pulse"></span>
            <span className="text-lg font-bold text-yellow-400">PRÓXIMAMENTE</span>
          </div>

          {/* Description */}
          <p className="text-gray-400 text-sm md:text-base mb-8 max-w-md mx-auto">
            Estamos preparando una sección completa de rulings y resolución de dudas sobre las cartas y mecánicas del juego.
            ¡Vuelve pronto!
          </p>

          {/* Features Preview */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
            <div className="glass-card rounded-xl p-4">
              <span className="text-2xl mb-2 block">🔍</span>
              <p className="text-sm text-gray-300 font-semibold">Búsqueda de Cartas</p>
              <p className="text-xs text-gray-500">Encuentra rulings específicos</p>
            </div>
            <div className="glass-card rounded-xl p-4">
              <span className="text-2xl mb-2 block">⚖️</span>
              <p className="text-sm text-gray-300 font-semibold">Resolución de Dudas</p>
              <p className="text-xs text-gray-500">Pregunta a la comunidad</p>
            </div>
            <div className="glass-card rounded-xl p-4">
              <span className="text-2xl mb-2 block">📚</span>
              <p className="text-sm text-gray-300 font-semibold">Base de Datos</p>
              <p className="text-xs text-gray-500">Rulings oficiales</p>
            </div>
          </div>

          {/* Back Button */}
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-pink-500 to-red-500 rounded-full text-white font-semibold hover:shadow-lg hover:shadow-pink-500/30 transition-all"
          >
            <ArrowLeft /> Volver al Inicio
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RulingsPage;
